import { render, staticRenderFns } from "./TabDatosSociedad.vue?vue&type=template&id=6a1e3dae"
import script from "./TabDatosSociedad.vue?vue&type=script&lang=js"
export * from "./TabDatosSociedad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1e3dae')) {
      api.createRecord('6a1e3dae', component.options)
    } else {
      api.reload('6a1e3dae', component.options)
    }
    module.hot.accept("./TabDatosSociedad.vue?vue&type=template&id=6a1e3dae", function () {
      api.rerender('6a1e3dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabDatosSociedad.vue"
export default component.exports